export default __webpack_public_path__ + "static/media/img8.e5a24da7.png";